import { Component } from '@angular/core';
import { ApiError, MessageService } from '../../../../../core';
import { OrigemID, Origem } from '../../../../common/origens/domain';
import { isTipoPessoaFisica, isTipoPessoaJuridica } from '../../../../pessoa/tipo';
import { Lead } from '../../lead';
import { LeadCrudHttpService } from '../../services';

interface Config {
    isOrigemCampanha: boolean;
    isOrigemMidiaSocial: boolean;
    isTipoPessoaFisica: boolean;
    isTipoPessoaJuridica: boolean;
    isOrigemPossuiCanalVenda?: boolean;
}

@Component({
    selector: 'sgt-lead-form-info',
    templateUrl: './lead-form-info.component.html',
    styleUrls: ['./lead-form-info.component.less']
})
export class LeadFormInfoComponent {
    config: Config;
    entity: Lead;

    constructor(private messageService: MessageService,
                private leadCrudHttpService: LeadCrudHttpService) { }

    private setConfig() {
        this.config = {
            isOrigemCampanha: OrigemID.isOrigemCampanha(this.entity?.origem ?? null),
            isOrigemMidiaSocial: OrigemID.isOrigemMidiaSocial(this.entity?.origem ?? null),
            isTipoPessoaFisica: isTipoPessoaFisica(this.entity?.tipoPessoa),
            isTipoPessoaJuridica: isTipoPessoaJuridica(this.entity?.tipoPessoa),
        };
        this.setConfigByOrigem();
    }

    /** Seta as configurações do form conforme a origem do cliente */
    private setConfigByOrigem() {
        if (!this.entity) {
            return;
        }
        // Obtendo a origem do cliente
        const origem = Origem.getById(this.entity.origem);

        // Somente exibe o canal de venda se a origem possuir
        this.config.isOrigemPossuiCanalVenda = origem?.possuiCanalVenda ?? false;
    }

    load(id: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.leadCrudHttpService.load(id)
                .subscribe(
                    entity => {
                        this.entity = entity;
                        this.setConfig();
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o Lead', error);
                        reject();
                    }
                );
        });
    }
}
